import { isEmpty } from 'lodash'
import moment from 'moment'

import i18n from 'modules/core/lib/i18n'

import { Expensable } from 'modules/expenses/types/Expensable'

export const buildPerDiemData = (expensable: Expensable) => {
  // Trip information fields for perdiem
  const from = expensable?.perDiem?.from
  const to = expensable?.perDiem?.to
  const startDate = expensable?.perDiem?.startDate
    ? moment(expensable.perDiem.startDate).format('DD/MM/YYYY HH:mm')
    : ''
  const endDate = expensable?.perDiem?.endDate
    ? moment(expensable.perDiem.endDate).format('DD/MM/YYYY HH:mm')
    : ''

  const items = [
    {
      title: i18n.t('expenses_v2.confirmation_screen.expense.trip_information_block.from'),
      info: from,
    },
    {
      title: i18n.t('expenses_v2.confirmation_screen.expense.trip_information_block.to'),
      info: to,
    },
    {
      title: i18n.t('expenses_v2.confirmation_screen.expense.trip_information_block.start_date'),
      info: startDate,
    },
    {
      title: i18n.t('expenses_v2.confirmation_screen.expense.trip_information_block.end_date'),
      info: endDate,
    },
  ]

  return items.filter(({ info }) => !isEmpty(info))
}
